<template>
  <v-container style="max-width:100vw;">
    <div style="background:white!important;" class="pa-4">
      <v-toolbar flat >
        <v-row class="ma-0 pt-6">
          <v-toolbar-title>
            Ventas por proveedor (sin IVA)
          </v-toolbar-title>
          <v-spacer/>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                rounded
                outlined
                dense
                v-model="dateRangeText"
                label="Rango de fechas"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                style="max-width: 320px"
              />
            </template>

            <v-card>
              <v-date-picker
                v-model="dates"
                range
                scrollable
              />
              <v-card-actions class="pt-0 mt-0">
                <v-spacer />
                <v-btn small text @click="menu = false">Cerrar</v-btn>
                <v-btn small rounded class="elevation-0" color="primary" @click="applyFilter">Aplicar</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-row>
      </v-toolbar>

      <div>
        <!--apexchart
          v-if="series.length"
          type="bar"
          height="420"
          :options="chartOptions"
          :series="series"
        /-->

        <v-data-table
          :headers="headers"
          :items="rows"
          :loading="loading"
          class="mt-4"
          dense
        >
          <template v-slot:item.total_cost="{ item }">
            {{ money(item.total_cost) }}
          </template>
          <template v-slot:item.total_sales="{ item }">
            {{ money(item.total_sales) }}
          </template>
          <template v-slot:item.total_utility="{ item }">
            {{ money(item.total_utility) }}
          </template>
          <template v-slot:body.append>
            <tr style="font-weight:600;">
              <td>Totales</td>
              <td>{{ totals.sales_count }}</td>
              <td>{{ totals.unique_items_count }}</td>
              <td>{{ totals.quantity_sold.toFixed(2) }}</td>
              <td>{{ money(totals.total_cost) }}</td>
              <td>{{ money(totals.total_sales) }}</td>
              <td>{{ money(totals.total_utility) }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>
  </v-container>
</template>

<script>
import axios from "axios"

export default {
  data() {
    return {
      loading: false,
      menu: false,
      dates: [undefined],
      rows: [],
      headers: [
        { text: "Proveedor", value: "provider" },
        { text: "Ventas", value: "sales_count" },
        { text: "SKUs", value: "unique_items_count" },
        { text: "Cantidad vendida", value: "quantity_sold" },
        { text: "Total costo", value: "total_cost" },
        { text: "Total ventas", value: "total_sales" },
        { text: "Utilidad", value: "total_utility" }
      ],
      series: [],
      chartOptions: {
        chart: { type: "bar", toolbar: { show: false }, zoom: { enabled: false } },
        plotOptions: { bar: { borderRadius: 4, horizontal: true } },
        dataLabels: { enabled: false },
        colors: ["#0ea5e9"],
        xaxis: {
          categories: [],
          labels: {
            formatter: (val) => this.money(val)
          }
        },
        tooltip: {
          y: {
            formatter: (val) => this.money(val)
          }
        }
      }
    }
  },

  computed: {
    dateRangeText() {
      const [start, end] = this.dates || []
      if (!start && !end) return ""
      if (start && !end) return start
      return `${start} - ${end}`
    },
    totals() {
      return this.rows.reduce((acc, row) => {
        acc.sales_count += Number(row.sales_count || 0)
        acc.unique_items_count += Number(row.unique_items_count || 0)
        acc.quantity_sold += Number(row.quantity_sold || 0)
        acc.total_cost += Number(row.total_cost || 0)
        acc.total_sales += Number(row.total_sales || 0)
        acc.total_utility += Number(row.total_utility || 0)
        return acc
      }, {
        sales_count: 0,
        unique_items_count: 0,
        quantity_sold: 0,
        total_cost: 0,
        total_sales: 0,
        total_utility: 0
      })
    }
  },

  created() {
    const date = new Date()
    this.dates = [
      new Date(date.getFullYear(), date.getMonth(), 1).toLocaleString("sv-SE", { timeZone: "America/Monterrey" }).toString().slice(0, 10),
      new Date(date.getFullYear(), date.getMonth() + 1, 0).toLocaleString("sv-SE", { timeZone: "America/Monterrey" }).toString().slice(0, 10)
    ]
    this.fetchReport()
  },

  methods: {
    money(value) {
      return new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(Number(value || 0))
    },

    applyFilter() {
      this.menu = false
      this.fetchReport()
    },

    async fetchReport() {
      const [start, end] = this.dates || []
      if (!start || !end) return

      this.loading = true
      try {
        const url = process.env.VUE_APP_BACKEND_ROUTE + "api/v2/reports/sales-by-provider"
        const { data } = await axios.get(url, {
          params: {
            "filter[date_between]": `${start},${end}`
          }
        })

        this.rows = data?.data || []
        this.series = [
          {
            name: "Total ventas",
            data: this.rows.map((row) => Number(row.total_sales || 0))
          }
        ]
        this.chartOptions.xaxis.categories = this.rows.map((row) => row.provider)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
